import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import {usePanelsTemplate} from 'Event/template/Panels'
import Title from 'lib/ui/ConfigPanel/Title'
import {Label} from 'lib/ui/typography'
import Slider from 'lib/ui/Slider'
import FontSelect from 'lib/FontSelect'
import ColorPicker from 'lib/ui/ColorPicker'

const DEFAULT_FONT_SIZE = 42
const MAX_FONT_SIZE = 50
const MIN_FONT_SIZE = 16

export default function Styling(props: {control: UseFormMethods['control']}) {
  const {control} = props
  const template = usePanelsTemplate()
  const welcomeTextColor = template.welcomeTextColor
    ? template.welcomeTextColor
    : template.textColor

  return (
    <>
      <Title>Typography</Title>
      <Label>Font</Label>
      <Controller
        control={control}
        name="welcomeTextFont"
        defaultValue={template.welcomeTextFont || null}
        render={({value, onChange}) => (
          <FontSelect value={value} onChange={onChange} />
        )}
      />
      <Controller
        name="welcomeTextColor"
        control={control}
        defaultValue={welcomeTextColor}
        render={({value, onChange}) => (
          <ColorPicker
            label="Font Color"
            aria-label="welcome text color"
            color={value}
            onPick={onChange}
          />
        )}
      />
      <Controller
        name="welcomeTextFontSize"
        defaultValue={template.welcomeTextFontSize || DEFAULT_FONT_SIZE}
        control={control}
        render={({value, onChange}) => (
          <Slider
            aria-label="welcome text font size"
            min={MIN_FONT_SIZE}
            max={MAX_FONT_SIZE}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Font Size"
          />
        )}
      />
    </>
  )
}
